module.exports = {"yytx15":{"daobanList":[{"title":"1:是否办理城乡居民养老保险待遇申领","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、有效身份证件","state":"必要"},{"name":"2、户口簿","state":"必要"},{"name":"3、社保卡或银行存折（卡）","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx15.json
// module id = 1314
// module chunks = 0